export var CustomPdfReportDataSourceEnum;
(function (CustomPdfReportDataSourceEnum) {
    CustomPdfReportDataSourceEnum["DEFAULT"] = "default";
    CustomPdfReportDataSourceEnum["LEGACY"] = "legacy";
})(CustomPdfReportDataSourceEnum || (CustomPdfReportDataSourceEnum = {}));
